export const ORG_HOME_PORTAL_NAME = "OrgHomePortal";
